<template>
    <div>
        <vx-card class="overflow-hidden" title="Employee Payslips" >
            <div class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row">
                <div class="vx-col sm:w-1/5 md:w-1/5 lg:w-1/5 xl:w-1/5 w-full mb-2" id="account-info-col-1">
                    <span  class="text-sm">Payout Date </span><span style="color:red">*</span>
                    <v-select class="mb-3" v-model="payOutDate" name="payOutDate-name" :options="payOutDateList" />
                    <vs-button type="gradient" color="primary" @click="downloadPayslip()" icon-pack="feather" icon="icon-download" :disabled="this.payOutDate == null">Download</vs-button>
                </div>
                <!-- <div class="vx-col sm:w-4/5 md:w-4/5 lg:w-4/5 xl:w-4/5 w-full mb-2" id="account-info-col-2"> -->
                <div class="vx-col flex-1" id="account-info-col-2">
                    <div id="div-with-loading"  class="scroll-content ex1 vs-con-loading__container" >
                        <input class="mb-3" v-show="payOutDate != null" v-model.number="page" type="number" style="width: 3em;padding:.3rem;font-size: 1rem;border: 1px solid rgba(0, 0, 0, .2);"/> <span class="text-sm" style="color:white"> / {{numPages}}</span>
                        <div v-if="loadedRatio > 0 && loadedRatio < 1" style="background-color: green; color: white; text-align: center" :style="{ width: loadedRatio * 100 + '%' }">{{ Math.floor(loadedRatio * 100) }}%</div>
                        <pdf class="overflow-hidden"
                            ref="pdf"
                            style="display: inline-block; width: 100%;"
                            :src="linkURL"
                            :page="page"
                            @password="password"  @error="error" @num-pages="numPages = $event" @link-clicked="page = $event"
                            >
                        </pdf>
                    </div>
                    <!-- <table>
                        <tr>
                            <td class="font-semibold">Username</td>
                        </tr>
                    </table> -->
                </div>
            </div>
        </vx-card>
    </div>

</template>


<script>
import pdf from 'vue-pdf'
import moment from 'moment' 
import vSelect from 'vue-select'
import axios from '@/axios.js'
import Swal from 'sweetalert2'
export default {
    
    components: {
		pdf,
        'v-select': vSelect,
        Swal,
	},
    data() {
		return {
			// src: loadingTask,
            page: 1,
			numPages: 0,

            loadedRatio: 0,

            payOutDateList: [],

            payOutDate: null,

            linkURL: '',
            p: 'Dela Cruz2007-004'
		}
	},
    computed: {
        
        convertPayOutDate() {
            return (d) => {
                var dt = moment(d, 'YYYYMMDD')
                return dt.format('DD-MMM-YYYY')
            }
        },
       
    },
    watch: {
        payOutDate() {
            this.linkURL = null
            this.loadingTask()
        },
        page() {
            if(this.page <= 0)
                this.page = 1
            else if(this.page > this.numPages)
                this.page = this.numPages

        }
    },
    created() {
       this.getPaylipList()
    },
    
    methods: {
        onViewPayslip(d){
            const data = {
                userId : this.$store.state.AppActiveUser.uid,
                payOutDate: moment(d).format('YYYYMMDD')
            }
            this.$store.dispatch('getViewPayslip', data)
        },
        getPaylipList() {
            this.payOutDateList=[]
            this.$vs.loading()
            this.$store.dispatch('getPayslipList', this.$store.state.AppActiveUser.uid )
                .then((response) => {
                    let p = response.data
                    p.forEach(payOutDate => {
                        this.payOutDateList.push(this.convertPayOutDate(payOutDate.substr(payOutDate.length - 8)))
                    })
                    this.$vs.loading.close()
                })
                .catch(() => { this.$vs.loading.close() })
        },
        loadingTask(){
             this.linkURL = null
            if(this.payOutDate != null){
                const data = {
                    userId : this.$store.state.AppActiveUser.uid,
                    payOutDate: moment(this.payOutDate).format('YYYYMMDD')
                }
                this.$store.dispatch('getViewPayslip', data)
                    .then((response) => {
                        this.linkURL =  response.request.responseURL
                    })
                    .catch((error) => {
                        this.linkURL = null
                        this.$alert(error, 'Error', 'error')
                    })
            } 
        },
        password: function(updatePassword, reason) {
            Swal.fire({
                    title: 'Enter your password',
                    input: 'password',
                    inputLabel: 'Password',
                    inputPlaceholder: 'Max of 10 characters',
                    inputAttributes: {
                    maxlength: 50,
                    autocapitalize: 'off',
                    autocorrect: 'off',
                    showCancelButton: true
                }
            })
            .then((t) => {
                if(t.isConfirmed) {
                    
                    updatePassword(t.value)
                    if(t.value == '') return
                    this.$vs.loading({
                        container: '#div-with-loading',
                        scale: 0.6
                    })
                    setTimeout( ()=> {
                            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                        }, 2000);
                }
                else{
                    Swal.fire('View Payslip','Cancelled', 'warning')
                    this.$router.go()
                }
                
            })
            .catch(() => { 
                Swal.fire('Payslip not loaded', "Cancelled", "warning"); 
            })
           
        //    updatePassword(this.$prompt('Please enter pdf password', 'Dela Cruz2007-004', 'Generate Payslip', 'info')
        //                 .then((res) => {
        //                     res
        //                 }))
            // this.$prompt('Please enter pdf password', 'Dela Cruz2007-004', 'Generate Payslip', 'info')
            //     .then((res) => {
            //         updatePassword(res)
            //          this.$vs.loading({
            //             container: '#div-with-loading',
            //             scale: 0.6
            //         })
            //         setTimeout( ()=> {
            //                 this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            //             }, 2000);
            //     })
            //     .catch(() => { 
                    
            //         this.$alert('Payslip not loaded', "Cancelled", "warning"); 
            //     })
           
		},
		error: function(err) {

			 this.$alert(err, 'Error', "error"); 
		},
        downloadPayslip() {
            axios.get(this.linkURL, {
                reportProgress: true,
                responseType: 'blob',
            }).then((response) => {
                    this.$vs.loading.close()
                    let fileName = response.headers['content-disposition'].split('filename=')[1].split('\;')[0]
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName.replace('"', '').replace('"', '')
                    link.click();

                  })
        },
    },
	
}
</script>
<style>
div.ex1 {
  background-color: #888888;
  width: 100%;
  overflow: auto;
  border: 1px solid;
  padding: 10px;
  border-radius:5px 0px 0px 5px;
  /* box-shadow: 5px 7px #888888; */
}
</style>
